import {createActionCreators, ImmerReducer} from 'immer-reducer'
import {DatabasesStateType, FiltersType} from './state'
class DatabasesGridSession extends ImmerReducer<DatabasesStateType> {
  searchQueryApplied(searchQuery: string) {
    this.draftState.gridSession.filters.searchQuery = searchQuery
  }
  filtersApplied(filters: FiltersType) {
    this.draftState.gridSession.filters = filters
  }
}

export const DatabasesGridSessionAC = createActionCreators(DatabasesGridSession)

export default DatabasesGridSession
